import z from "zod";
import { timestampsSchema } from "../helpers";
import { LABEL_DESCRIPTION_MAX, labelDescriptionSchema, } from "../preAnnotateSettings/preAnnotateSettings.schema";
export const labelSchema = z.object({
    id: z.number(),
    name: z.string(),
    color: z.string(),
    description: z.string().max(LABEL_DESCRIPTION_MAX).nullable(),
    ...timestampsSchema,
});
export const createLabelSchema = labelSchema
    .pick({
    name: true,
    color: true,
})
    .extend({
    name: z.string().trim().min(1).max(256),
    description: labelDescriptionSchema.nullable().optional(),
    renameArchived: z
        .object({
        labelId: z.number().int().positive(),
        name: z.string().trim().min(1).max(256),
    })
        .optional(),
});
export const updateLabelSchema = createLabelSchema;
export const archivedLabelSchema = labelSchema.extend({
    regionCount: z.number().int().nonnegative(),
});
export const labelUsageSchema = z.object({
    models: z.number().int().nonnegative(),
    annotations: z.number().int().nonnegative(),
    tasks: z.number().int().nonnegative(),
    tasksBecomingEmpty: z.number().int().nonnegative(),
    evalLimits: z.number().int().nonnegative(),
});
//# sourceMappingURL=label.schema.js.map